import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts'
import VueI18n from 'vue-i18n';

Vue.component('apexchart', VueApexCharts)

Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.withCredentials = true;
// Vue.prototype.$http.defaults.timeout === 2500;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['x-auth'] = token
}

Vue.prototype.$http.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status == 401) {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["x-auth"];
    router.push('login')
  }
  return Promise.reject(error);
})

Vue.config.productionTip = false

Vue.use(require('vue-moment'))

Vue.use(VueI18n);

const loadLocaleMessages = () => {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = new VueI18n({
  locale: navigator.language.split("-")[0],
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
